// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrapper":"style_breadcrumbWrapper__m2M_y","ant-breadcrumb-link":"style_ant-breadcrumb-link__CQ_Fu"};